import { MdFavoriteBorder } from "react-icons/md";
import { MdOutlineBookmarkBorder } from "react-icons/md";
import { IoBagOutline } from "react-icons/io5";
import { PiNumberFiveFill } from "react-icons/pi";
import { GoPerson } from "react-icons/go";
import { LiaAddressCardSolid } from "react-icons/lia";
import { MdPayment } from "react-icons/md";
import { CiLogout } from "react-icons/ci";
import { FaRegEdit } from "react-icons/fa";
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from "../context/AuthProvider";
import { logout } from "../apis/authApi";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";

const Account = () => {
  const {user,setUser,setLogin} = useAuth()
  const wishList = useSelector(state=>state.wish.wish)
  const navigate = useNavigate()
  return (
    <div className=" w-full md:w-80 md:sticky top-5 h-fit self-start ">
      <div className="w-full md:w-80 border border-gray-300 ">
       
        <div className="flex p-5 gap-5">
          <img className="rounded-full" src="/assets/ava.jpg" width={60} height={60} />
          <div className="flex flex-col mt-2">
            <h6 className="text-sm font-bold">{user?.name}</h6>
            <span className="text-sm text-primary">{user?.email}</span>
          </div>
        </div>

      
        <div className="p-5 bg-gray-100 w-full">
          <span className="font-bold text-black">Dashboard</span>
        </div>
        <div className="flex flex-col gap-4 text-gray-700 p-4">
          <div className="cursor-pointer hover:text-primary">
            <div className="flex justify-between">
              <div className="flex gap-2">
                <IoBagOutline className="text-xl" />
                <Link to="">Order</Link>
              </div>
              <div className="flex justify-center bg-gray-700 text-white text-sm w-4 items-center h-4">{user?.purchaseHistory?.length}</div>
            </div>
            <div className="mt-3">
              <hr className="border-t border-gray-300" />
            </div>
          </div>

          <div className="cursor-pointer hover:text-primary">
            <div className="flex justify-between">
              <div className="flex gap-2">
                <MdFavoriteBorder className="text-xl" />
                <Link to="wishlist">Wishlist</Link>
              </div>
              <div className="flex justify-center bg-gray-700 text-white text-sm w-4 items-center h-4">{wishList.length}</div>
            </div>
            <div className="mt-3">
              <hr className="border-t border-gray-300" />
            </div>
          </div>

          {/* <div className="cursor-pointer hover:text-primary">
            <div className="flex justify-between">
              <div className="flex gap-2">
                <MdOutlineBookmarkBorder className="text-xl" />
                <Link to="tickets">Support Tickets</Link>
              </div>
              <div className="flex justify-end"><PiNumberFiveFill /></div>
            </div>
            <div className="mt-3">
              <hr className="border-t border-gray-300" />
            </div>
          </div> */}
        </div>

       
        <div className="p-5 bg-gray-100 w-full">
          <span className="font-bold text-black">Account Setting</span>
        </div>
        <div className="flex flex-col gap-4 text-gray-700 p-4">
          <div className="cursor-pointer hover:text-primary">
            <div className="flex justify-between">
              <div className="flex gap-2">
                <GoPerson className="text-xl" />
                <Link to="profile">Profile Info</Link>
              </div>
            </div>
            <div className="mt-3">
              <hr className="border-t border-gray-300" />
            </div>
          </div>

          <div className="cursor-pointer hover:text-primary">
            <div className="flex justify-between">
              <div className="flex gap-2">
                <LiaAddressCardSolid className="text-xl" />
                <Link to="address">Addresses</Link>
              </div>
            </div>
            <div className="mt-3">
              <hr className="border-t border-gray-300" />
            </div>
          </div>

          {/* <div className="cursor-pointer hover:text-primary">
            <div className="flex justify-between">
              <div className="flex gap-2">
                <MdPayment className="text-xl" />
                <Link to="payment">Payment</Link>
              </div>
            </div>
            <div className="mt-3">
              <hr className="border-t border-gray-300" />
            </div>
          </div> */}

          <div className="cursor-pointer hover:text-primary">
            <div className="flex justify-between">
              <div className="flex gap-2" onClick={()=>{
                logout().then(res=>{
                  toast.success(res.message)
                  navigate('/')
                  setUser(null)
                  setLogin(false)
                }).catch(err=>
                  toast.error(err?.response?.data?.message)
                )
              }}>
                <CiLogout className="text-xl" />Logout
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Account;
